import { withStateHandlers } from "recompose";

export const withAlertState = withStateHandlers(
  { isOpen: false },
  {
    openAlert: () => () => ({ isOpen: true }),
    closeAlert: () => () => ({ isOpen: false })
  }
);



// WEBPACK FOOTER //
// ./src/app/hocs.js